import { FC } from 'react';
import styles from './NameOfTile.module.css';

export const NameOfTile: FC<{ name?: string }> = ({ name }) => {
  return !name ? null : <p className={styles.name}>{name}</p>;
};
